// extracted by mini-css-extract-plugin
export default {"Accordion":"Accordion_Accordion__MDI4M"};